import React from 'react';

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex flex-col">
      <header className="bg-white dark:bg-gray-800 shadow">
        <div className="max-w-4xl mx-auto py-4 px-4 flex items-center space-x-2">
        <span className="text-1xl text-blue-500 dark:text-blue-300">&lt;&lt;</span>
          <a href="/logout" className="text-gray-900 dark:text-gray-100 hover:underline">
            Back to main page
          </a>
        </div>
      </header>
      <main className="flex-grow max-w-4xl mx-auto p-6 text-gray-800 dark:text-gray-200">
        <h2 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-gray-100">
          Legal Notice
        </h2>

        <section className="mb-4">
          <h3 className="text-lg font-medium mb-2 text-gray-800 dark:text-gray-200">Betreiber</h3>
          <p className="text-gray-700 dark:text-gray-300">
            [Fabian Kern]<br />
            [Vermontring 13c]<br />
            [76149 Karlsruhe]<br />
            [Deutschland]<br />
          </p>
        </section>

        <section className="mb-4">
          <h3 className="text-lg font-medium mb-2 text-gray-800 dark:text-gray-200">Kontakt</h3>
          <p className="text-gray-700 dark:text-gray-300">
            E-Mail: [legal-notice[at]fabiankern.com]<a className="text-blue-600 dark:text-blue-400 hover:underline"></a>
          </p>
        </section>
      </main>
    </div>
  );
}